import { render, staticRenderFns } from "./ConfirmAdmission.vue?vue&type=template&id=132f92ca&scoped=true"
import script from "./ConfirmAdmission.vue?vue&type=script&lang=js"
export * from "./ConfirmAdmission.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAdmission.vue?vue&type=style&index=0&id=132f92ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f92ca",
  null
  
)

export default component.exports